/* eslint-disable max-len */
import 'react';

const ArrowDownSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
        <g fill="none">
            <path
                d="M20.049 7.551a1.2 1.2 0 00-1.531-.138l-.167.138L12 13.903 5.649 7.551a1.2 1.2 0 00-1.531-.138l-.167.138a1.2 1.2 0 00-.138 1.531l.138.167 7.2 7.2a1.2 1.2 0 001.531.138l.167-.138 7.2-7.2a1.2 1.2 0 000-1.698z"
                fill="currentColor"
            />
        </g>
    </svg>
);
export default ArrowDownSvg;
